module.exports = __webpack_public_path__ + "img/medalTitle.ef7753ba.png";